import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { AuthCallbackComponent } from './auth-callback.component';

import { FormsModule } from '@angular/forms';


@NgModule({
    imports: [SharedModule,FormsModule],
    declarations: [AuthCallbackComponent],
    exports: [AuthCallbackComponent],
    entryComponents: [AuthCallbackComponent]
})
export class AuthcllbackModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authentication/auth-callback/auth-callback.module.ts